import { ADD_FLASH_MESSAGE, DELETE_FLASH_MESSAGE, POP_FLASH_MESSAGE } from "../actions/flashMessages.actions";
import shortid from 'shortid';
import findIndex from 'lodash/findIndex';
import { RESET_STORE } from '../actions/config.actions';

export default (state = [], action = {}) => {
  let index = 0;
  let { message } = action;
  switch (action.type) {
    case ADD_FLASH_MESSAGE:
      index = findIndex(state, { id: message.id });
      if (index < 0) {
        return [
          ...state,
          {
            ...message,
            id: message.id || shortid.generate(),
          }
        ];
      }
      return state;
    case DELETE_FLASH_MESSAGE:
      index = findIndex(state, { id: action.id });
      if (index >= 0) {
        return [
          ...state.slice(0, index),
          ...state.slice(index + 1)
        ];
      }
      return state;
    case POP_FLASH_MESSAGE:
      if (state.length === 0) return state;
      return state.slice(1);
    case RESET_STORE:
      return [];
    default: return state;
  }
};